import { useCallback } from 'react';

import { type UseGallerySectionHeaderParams } from '~/components/Gallery/useGallerySectionHeader';
import { GalleryNestedEmptyStateHeader } from '~/components/v2/components/shared/gallery/GalleryNestedEmptyStateHeader';
import { GalleryNestedSectionHeader } from '~/components/v2/components/shared/gallery/GalleryNestedSectionHeader';

export type UseGalleryNestedHeaderControlsParams = {
  canShowNestedItemsChip: boolean;
  isDisabled: boolean;
  /** Showcase listing blocks pass false for every gallery except the one that should hold the chip. */
  isNestedChipHost: boolean;
};

/** Header wiring shared by public board and showcase galleries. Each section header uses its own item count. */
export const useGalleryNestedHeaderControls = ({
  canShowNestedItemsChip,
  isDisabled,
  isNestedChipHost,
}: UseGalleryNestedHeaderControlsParams) => {
  const renderHeader = useCallback<NonNullable<UseGallerySectionHeaderParams['renderHeader']>>(
    (header) => <GalleryNestedSectionHeader {...header} isDisabled={isDisabled} isNestedChipHost={isNestedChipHost} />,
    [isDisabled, isNestedChipHost],
  );

  return {
    emptyStateHeader: canShowNestedItemsChip ? <GalleryNestedEmptyStateHeader /> : undefined,
    renderHeader,
  };
};
